<template>
  <div v-if="publicationDatas" class="mastermind-publication-table-page col-block width-full">
    <div class="data-table-container col-block width-full">
      <div class="data-table-block col-block width-full">
        <div class="data-row-container col-block width-full">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOptions" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content" v-html="option.title"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
      <div :ref="'publication-container'" class="data-table-block col-block width-full" :style="{ 'max-height': '60vh' }">
        <div :ref="'publication-data-' + data.index" class="data-row-container col-block width-full" v-for="(data) in filtedPublicationDatas" :key="data.index">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOptions" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1, width: 0 }">
              <div :style="{ flex: 1 }"></div>
              <template v-if="option.value === '_DETAILS'">
                <div class="detail-container row-block flex-end">
                  <div class="detail-content-container col-block width-full" :style="{ flex: 1, width: 0 }">
                    <div class="detail-content-citation" :title="data.citation">{{ data.citation }}</div>
                    <div class="detail-content-title" :title="data.title">{{ data.title }}</div>
                  </div>
                  <div class="detail-option-container col-block width-full">
                    <div :style="{ flex: 1 }"></div>
                    <div class="detail-display-abstract" :class="{ active: detailIndex === data.index }" @click="e => detailIndex = data.index">{{ $t('COMPONENT.case.mastermindPublicationTable.table.info.details.___open') }}</div>
                  </div>
                </div>
              </template>
              <template v-else-if="option.value === '_PMID'">
                <div class="pmid-container row-block">
                  <div class="pmid">{{ data.pmid }}</div>
                  <a :href="'https://pubmed.ncbi.nlm.nih.gov/' + data.pmid" target="_blank">
                    <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                  </a>
                </div>
              </template>
              <template v-else>
                <div class="data-content" v-html="data[option.value] || option.empty || '- -'"></div>
              </template>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
          <div v-if="detailIndex === data.index" class="data-detail-container col-block width-full">
            <div class="data-detail-hide-block row-block" @click="e => detailIndex = null">
              <div class="data-detail-hide">{{ $t('COMPONENT.case.mastermindPublicationTable.table.info.details.___hide') }}</div>
              <div class="icon-block" :style="{ '--size': '16px' }">
                <img :src="require('../../assets/images/case-edit-display-icon.svg')" alt="" :style="{ width: '11.2px' }">
              </div>
            </div>
            <div class="data-detail-block col-block width-full">
              <div class="data-detail">{{ data.abstract }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="pageData" class="data-page-container row-block">
      <div :style="{ width: '10px' }"></div>
      <div class="data-page-total">{{ $t('COMPONENT.case.mastermindPublicationTable.page.___total', { total: toPriceString(pageData.total) }) }}</div>
      <div :style="{ flex: 1 }"></div>
      <div class="data-page-display">{{ $t('COMPONENT.case.mastermindPublicationTable.page.___display', { display: pageData.display }) }}</div>
      <div :style="{ width: '20px' }"></div>
      <pageButtons
        :default="pageData.selectedPage"
        :display="pageData.display - 0"
        :total="pageData.total"
        :buttonRange="pageData.buttonRange"
        @selectPage="page => { pageData.selectedPage = page }"
      ></pageButtons>
    </div>
  </div>
</template>

<script>
import { getMastermindPublications } from '../../api'
import pageButtons from '../tool/pageButtons.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import { defaultEmptyDisplay } from '../../constants/global/data'
import { toPriceString } from '../../constants/global/util'

export default {
  components: {
    pageButtons
  },
  mixins: [
    routeLoading
  ],
  props: {
    pmids: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      publicationDatas: null,
      detailIndex: null,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 0,
        buttonRange: 7
      }
    }
  },
  computed: {
    filtedPublicationDatas () {
      let filtedPublicationDatas = [...(this.publicationDatas || [])]
      filtedPublicationDatas = filtedPublicationDatas.filter((_, i) => i >= (this.pageData.display * (this.pageData.selectedPage - 1)) && i < (this.pageData.display * this.pageData.selectedPage))
      return filtedPublicationDatas
    },
    // static
    tableOptions () {
      return [
        {
          title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___no'),
          value: 'index',
          style: null,
          width: '60px',
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___details'),
          value: '_DETAILS',
          style: null,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('COMPONENT.case.mastermindPublicationTable.table.title.___PMID'),
          value: '_PMID',
          style: null,
          width: '160px',
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ]
    },
    // global
    toPriceString () { return toPriceString }
  },
  watch: {
    'pageData.selectedPage' () {
      const container = this.$refs['publication-container']
      container && setTimeout(() => {
        container.scrollTo({ top: 0 })
      })
    },
    'detailIndex' (nv) {
      if (![null, undefined].includes(nv)) {
        const container = this.$refs['publication-container']
        const child = this.$refs['publication-data-' + nv][0]
        setTimeout(() => {
          container.scrollTo({ top: child.offsetTop - container.offsetTop })
        })
      }
    }
  },
  activated () {
    this.pageData.selectedPage = 1
    const container = this.$refs['publication-container']
    container && setTimeout(() => {
      container.scrollTo({ top: 0 })
    })
  },
  methods: {
    async fetchData () {
      await this.fetchMastermindPublication()
    },
    async fetchMastermindPublication () {
      try {
        let config = this.$ls.get('userInfo')
        let pmid = this.pmids.join(',')
        let response = await getMastermindPublications(pmid, config)
        let publicationDatas = response.data.data
        publicationDatas = publicationDatas.filter(data => data.pmid).map((data, index) => ({ index: index + 1, ...data }))
        this.pageData.total = publicationDatas.length
        this.publicationDatas = publicationDatas
      } catch (error) {
        throw error
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/mastermindPublicationTable.vue